import React, { useState } from 'react';
import { Camera, X } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { AvatarUploadDialog } from './AvatarUploadDialog';

const KEY = 'avatar_reminder_dismissed';

// Lembrete para quem ainda não tem foto de perfil (volta a aparecer em cada nova sessão)
export const AvatarReminder = () => {
  const { user, refreshUser, previewPartner } = useAuth();
  const [hidden, setHidden] = useState(() => sessionStorage.getItem(KEY) === '1');
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  if (!user || user.avatar_url || hidden || previewPartner || pathname.startsWith('/chat') || pathname.startsWith('/profile')) return null;
  const dismiss = () => { sessionStorage.setItem(KEY, '1'); setHidden(true); };
  return (
    <>
      <div className="fixed bottom-24 left-3 right-3 sm:right-auto sm:left-6 lg:left-72 sm:bottom-6 sm:w-72 z-40 rounded-xl bg-white/95 backdrop-blur border border-[#4DD4E8]/40 shadow-lg p-3 flex gap-3 items-start" data-testid="avatar-reminder">
        <span className="w-10 h-10 rounded-full bg-[#4DD4E8]/15 text-[#0e7490] flex items-center justify-center shrink-0"><Camera className="w-5 h-5" /></span>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-slate-800">Ainda não tem foto de perfil</p>
          <p className="text-xs text-slate-500 mb-2">A sua foto aparece no CRM e no chat da equipa.</p>
          <button type="button" onClick={() => setOpen(true)} className="text-xs font-semibold px-3 py-1.5 rounded-full bg-[#2D3E6F] text-white hover:bg-[#24335c]" data-testid="avatar-reminder-upload">Carregar foto</button>
        </div>
        <button type="button" onClick={dismiss} className="text-slate-400 hover:text-slate-700" title="Lembrar mais tarde" data-testid="avatar-reminder-dismiss"><X className="w-4 h-4" /></button>
      </div>
      <AvatarUploadDialog open={open} onClose={() => setOpen(false)} userId={user.id} name={user.name} currentUrl={user.avatar_url} onSaved={() => refreshUser()} />
    </>
  );
};
